document.addEventListener('DOMContentLoaded', () => {
  const wordContainer = document.querySelector('.js-word-change');
  const wordWrapper = document.querySelector('.js-word');

  if (wordContainer) {
    const firstWord = wordContainer.textContent.trim();
    let words = JSON.parse(wordWrapper.getAttribute('data-words'));
    if (!words.includes(firstWord)) {
      words.unshift(firstWord);
    }

    let index = 1;

    function changeWord() {
      wordContainer.classList.add('fade-out');

      setTimeout(() => {
        wordContainer.textContent = words[index];
        index = (index + 1) % words.length;

        wordContainer.classList.remove('fade-out');
        wordContainer.classList.add('fade-in');

        setTimeout(() => wordContainer.classList.remove('fade-in'), 200);
      }, 200);
    }

    setInterval(changeWord, 2000);
  }
});
